/* Addlore cart hook — logic only.
   20-09-2026: moved out of snippets/adl-cart-hook.liquid. The one Liquid value it used,
   routes.cart_url, is handed over on window.ADL_CART_URL by the tiny inline block that remains. */

(function(){
  function openDrawer(){ if(window.adlCartDrawer) window.adlCartDrawer.open(); }
  function isAdd(u){ return typeof u==='string' && u.indexOf('/cart/add')>-1; }

  /* ---------------------------------------------------------------
     0. Razorpay Magic Checkout

     (a) The plugin binds to the theme's cart form, which Shopify themes give the
         id "cart". Our drawer posts the same form under its own id, so rename it
         at load — before any click, since the plugin's listener runs ahead of
         anything we could do during the event — and re-point the button on every
         re-render.

     (b) Cold start: the plugin's first click after a page load only initialises
         it; no sheet appears. The second click opens it. Left alone, a customer's
         first tap on checkout does nothing at all.
         So the button shows a pending state and re-clicks ITSELF until the sheet
         is on screen. It must be a click — form.requestSubmit() bypasses the
         plugin entirely and drops the customer into native Shopify checkout,
         losing Magic Checkout. That was tested and is exactly what we must not do.

     Detection note: .razorpay-backdrop and iframe.razorpay-checkout-frame exist
     from page load even while closed. Only .razorpay-container-visible means the
     sheet is really up.
     --------------------------------------------------------------- */
  function nameForm(){
    var f=document.getElementById('adlCartCheckout');
    if(f && !document.getElementById('cart')) f.id='cart';
  }
  function pointButton(){
    if(!document.getElementById('cart')) return;
    var go=document.querySelector('.adlcd .go');
    if(go) go.setAttribute('form','cart');
  }
  function bindForm(){
    nameForm();
    var b=document.getElementById('adlCartBody');
    if(!b) return false;
    new MutationObserver(pointButton).observe(b,{childList:true,subtree:true});
    pointButton();
    return true;
  }
  if(!bindForm()){ document.addEventListener('DOMContentLoaded',bindForm); setTimeout(bindForm,1200); }

  function sheetOpen(){ return !!document.querySelector('.razorpay-container-visible'); }

  var busy=false;
  document.addEventListener('click',function(e){
    var go=e.target.closest && e.target.closest('.adlcd .go');
    if(!go) return;
    if(busy) return;                 /* our own synthetic re-click — let it pass through */
    busy=true;
    var label=go.innerHTML, tries=0;
    go.setAttribute('aria-busy','true');
    go.innerHTML='opening checkout';
    var t=setInterval(function(){
      if(sheetOpen()){
        clearInterval(t); busy=false;
        go.removeAttribute('aria-busy'); go.innerHTML=label;
        return;
      }
      if(++tries>6){
        clearInterval(t); busy=false;
        go.removeAttribute('aria-busy'); go.innerHTML=label;
        window.location=''+window.ADL_CART_URL+'';   /* checkout always works there */
        return;
      }
      go.click();
    },800);
  },true);

  /* 1. any link or control that points at the cart — capture phase, so the
     theme's own handler cannot swallow the click before we see it. */
  document.addEventListener('click',function(e){
    var el=e.target.closest? e.target : e.target.parentElement;
    if(!el||!el.closest) return;
    if(el.closest('.adlcd')) return;
    var t=el.closest('a[href*="/cart"], a[href$="/cart"], #cart-icon-bubble, .cart-icon, .cart-link, [data-adl-open]');
    if(t){ e.preventDefault(); e.stopPropagation(); openDrawer(); }
  },true);

  /* 2. the old drawer being opened by the theme's own script */
  function watch(){
    var old=document.getElementById('cart-drawer');
    if(!old) return false;
    var hidden=function(){ return old.classList.contains('hidden')||old.classList.contains('translate-x-full'); };
    var was=hidden();
    new MutationObserver(function(){
      var now=hidden();
      if(was && !now) openDrawer();
      was=now;
    }).observe(old,{attributes:true,attributeFilter:['class','style']});
    return true;
  }
  if(!watch()){ document.addEventListener('DOMContentLoaded',watch); setTimeout(watch,1500); }

  /* 3. anything on the page adding to cart, whichever transport it uses */
  var of=window.fetch;
  window.fetch=function(){
    var u=arguments[0]; u=(u&&u.url)?u.url:u;
    var p=of.apply(this,arguments);
    if(isAdd(u)) p.then(function(r){ if(r&&r.ok) setTimeout(openDrawer,150); });
    return p;
  };
  var oo=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(m,u){
    if(isAdd(u)) this.addEventListener('load',function(){ if(this.status<300) setTimeout(openDrawer,150); });
    return oo.apply(this,arguments);
  };
  /* THE SUBMITTER CARRIES THE QUANTITY ON V3. Measured 16-09-2026: the rebuilt buy box has
     no quantity input at all - it has EIGHT submit buttons named "quantity", one per pack
     size, and CSS shows only the one the chosen pack matches. That is what makes the stepper
     work with JavaScript switched off. But `new FormData(form)` does NOT include the button
     that submitted the form, so this handler was posting no quantity and Shopify was
     defaulting to 1: pressing "add to cart" on the two-tin pack put ONE tin in the cart.
     Native form submission includes the submitter, which is why the bug only appeared once
     this hook started intercepting. FormData's second argument does the same thing in current
     browsers; the append below covers the ones where it does not. */
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f||!f.getAttribute) return;
    if((f.getAttribute('action')||'').indexOf('/cart/add')===-1) return;
    e.preventDefault();
    var s=e.submitter, fd;
    try{ fd=new FormData(f,s); }catch(err){ fd=new FormData(f); }
    if(s&&s.name&&!fd.has(s.name)) fd.append(s.name,s.value);
    /* 17-09-2026, Ajay: the customer must SEE "added to cart" before the drawer covers the page (on a phone it
       covers all of it). Product-page form only: say added, then open the drawer 900 ms later. */
    fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){
      if(f.id==='pdp-form' && r && r.ok){ document.documentElement.setAttribute('data-cart','added'); setTimeout(openDrawer,900); }
      else openDrawer();
    });
  },true);
})();

